import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { Room, Search, TuneRounded as Tune } from '@material-ui/icons';
import { getFormationsMap } from '@webapps/business';
import {
  FormikTextField50,
  ModalSideBar,
  useQuery,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

import FiltersFormation from './FiltersFormation';
import ResultsFormation from './ResultsFormation';

const filterSchema = yup.object().shape({
  keyword: yup.string(),
  schools: yup.array(),
  cities: yup.string(),
  // cities: yup.array().of(yup.string()),
  studyPlans: yup.array(),
  degrees: yup.array(),
  domains: yup.array(),
  trainingTypes: yup.array(),
});

const Formations = ({
  isFetching,
  load,
  formations,
  info,
  setInfo,
  page,
  setPage,
  totalElements,
  formik,
  resetParamsUrl,
  partnersAccepted,
  partnersRequested,
  partnersReceived,
  handleRefetch,
  accountInfos,
}) => {
  const {
    classes,
    css,
    theme: { spacing },
  } = useStyles(styles);

  // const [value, setValue] = useState('1');
  // const intl = useIntl();

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  const [filterFormationOpened, setFilterFormationOpened] = useState(false);

  const handleFilterFormationClose = () => {
    setFilterFormationOpened(false);
  };

  const handleFilterFormationOpen = () => {
    setFilterFormationOpened(true);
  };

  return (
    <>
      {formations?.length > 0 ? (
        <ResultsFormation
          formations={formations}
          isFetching={isFetching}
          handleRefetch={handleRefetch}
          info={info}
          setInfo={setInfo}
          load={load}
          page={page}
          setPage={setPage}
          totalPage={totalElements}
          partnersAccepted={partnersAccepted}
          partnersRequested={partnersRequested}
          partnersReceived={partnersReceived}
          accountInfos={accountInfos}
        />
      ) : (
        <div className={css({ background: '#F3F7FF', marginTop: spacing(5) })}>
          <div
            className={css({
              background: 'white',
              display: 'flex',
              justifyContent: 'center',
              padding: spacing(5),
            })}
          >
            Aucune formation correspondante trouvée.
          </div>
        </div>
      )}
      <ModalSideBar
        handleClose={handleFilterFormationClose}
        open={filterFormationOpened}
        title="Filtres"
        width="500px"
      >
        <FiltersFormation
          formik={formik}
          resetParamsUrl={resetParamsUrl}
          handleClose={handleFilterFormationClose}
        />
      </ModalSideBar>
    </>
  );
};

const styles = ({ spacing }) => ({});

export default Formations;
